import { createContext, useState } from "react";

import ZonesService from "../services/zones.service";

export const ZonesContext = createContext();

export const ZonesProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [zones, setZones] = useState([]);
  const [zoneGroups, setZoneGroups] = useState([]);
  const [zonesCount, setZonesCount] = useState(0);

  const contextZones = {
    loading,
    zones,
    zonesCount,
    zoneGroups,

    getZones: async (filters) => {
      setLoading(true);
      const response = await ZonesService.getZones(filters);
      setZones(response.data?.zones || []);
      setZonesCount(response.data?.total_rows || 0);
      setLoading(false);

      return response.data;
    },

    getZoneGroups: async (groups) => {
      setLoading(true);

      if (!Array.isArray(groups)) {
        groups = [groups];
      }

      let response = {};
      await Promise.all(
        groups.map(async (group) => {
          const resp = await ZonesService.getZoneGroups(group);
          response[group] = resp.data;
        }),
      );

      setZoneGroups(JSON.parse(JSON.stringify(response)));
      setLoading(false);

      return response.data;
    },

    toggleZoneItem: async (zone, item_type, item_id) => {
      setLoading(true);
      let response;
      try {
        response = await ZonesService.toggleGroupItem(zone, item_type, item_id);
      } catch (e) {
        response = e.response;
        console.log(e.response.data);
      }
      setLoading(false);
      console.log("PResponse", response?.data);
      return response?.data;
    },

    getZone: async (id) => {
      setLoading(true);
      const response = await ZonesService.getZone(id);
      setLoading(false);

      return response.data;
    },

    createZone: async (item) => {
      setLoading(true);
      const response = await ZonesService.createZone(item);
      if (!response.error) {
        // Nothing
      } else {
        console.warn("Error creating Zones");
      }
      setLoading(false);

      return response.data;
    },

    editZone: async (item) => {
      setLoading(true);
      const response = await ZonesService.editZone(item);
      if (!response.error) {
        // Nothing
      } else {
        console.warn("Error creating Zones");
      }
      setLoading(false);

      return response.data;
    },

    removeZone: async (item) => {
      setLoading(true);
      const response = await ZonesService.removeZone(item);
      if (!response.error) {
        // Nothing
      } else {
        console.warn("Error creating Zones");
      }
      setLoading(false);

      return response.data;
    },
  };

  return (
    <ZonesContext.Provider value={contextZones}>
      {children}
    </ZonesContext.Provider>
  );
};
